import $ from "jquery"

let Clean_Form;

Clean_Form = (() => {
  function Clean_Form() {
    let $inputs;
    let onClass;
    let showClass;
    onClass = "on";
    showClass = "show";
    $inputs = $(
      ".new-form input:not([type='checkbox']):not([type='radio']), .new-form textarea, .new-form select",
    );
    if ($inputs.hasClass("error")) {
      console.log("input has an error");
      $inputs.on("focus", function() {
        return $(this)
          .removeClass("error")
          .next("label")
          .removeClass("error show on");
      });
    } else {
      $inputs
        .on("checkval", function() {
          let label;
          label = $(this).next("label");
          if (this.value !== "") {
            return label.addClass(showClass);
          } else {
            return label.removeClass(showClass);
          }
        })
        .on("keyup", function() {
          return $(this).trigger("checkval");
        })
        .on("focus", function() {
          return $(this).next("label").addClass(onClass);
        })
        .on("blur", function() {
          return $(this).next("label").removeClass(onClass);
        })
        .trigger("checkval");
    }
  }

  return Clean_Form;
})();

export default new Clean_Form();
